import "./LodgedSpecificCollateralComponent.scss";
import {LodgedCollateralTableRow} from "../../models/table/LodgedCollateralTableRow";
import {ComponentCallback} from "../../../../../types/AngularJS";
import {LodgedCollateral} from "../../models/table/LodgedCollateral";
import {LodgeAmountService} from "../../service/lodge-amount/LodgeAmountService";

export const LodgedSpecificCollateral = "lodgedSpecificCollateral";

export function lodgedSpecificCollateral() {
    return {
        templateUrl: "app/portfolio/templates/collateral/lodge/lodged-specific/LodgedSpecificCollateralComponent.html",
        bindings: {
            rows: "<",
            onUnlodge: "&"
        },
        controllerAs: "ctrl",
        controller: LodgedSpecificCollateralComponentController
    };
}

export class LodgedSpecificCollateralComponentController {

    public rows: Array<LodgedCollateralTableRow>;
    public onUnlodge: ComponentCallback;

    /** @ngInject */
    public constructor(private lodgeAmountService: LodgeAmountService) {

    }

    public async unlodge(collateral: LodgedCollateral) {
        // const max = collateral.used!;
        // const amount = await this.lodgeAmountService.openLodgeAmount(max);
        const quantity = collateral.quantity;
        this.onUnlodge({
            code: collateral.code,
            quantity
        });
    }
}
